import { cn } from '@/lib/ui/utils';
import type { ReactNode } from 'react';
import { CmsSurface } from './cms-surface';

export function CmsMediaFrame({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <CmsSurface variant="media" className={cn('cms-media-frame', className)}>
      {children}
    </CmsSurface>
  );
}
